import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as DeliveryHttp from '../../../../services/api/https/deliveries/delivery.http.js'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOAD_DATA: 'Carregando dados',
}

const INITIAL_STATE = {
  firstRenderComplete: false,
  customers: [],
  geolocations: [],
  loadingMessage: LOAD_MESSAGE.LOAD_DATA,
  errorMessage: null,
  isLoading: false,
}

export default function useGeoposicionamentoVeiculo() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.LOAD_DATA }))
      },

      async getGeolocationClientsByFleet(fleet_id) {
        try {
          const { clients, geolocations } =
            await DeliveryHttp.getGeolocationClientsByFleet(fleet_id)

          const geolocationsLimited = this.limitarGeolocations(geolocations)

          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NONE,
            customers: clients,
            geolocations: geolocationsLimited.map(geo => [geo.longitude, geo.latitude]),
          }))
        } catch (error) {
          setState(prevState => ({ ...prevState, errorMessage: errorHandler(error) }))
        }
      },

      limitarGeolocations(geolocations, maxItens = 150) {
        const total = geolocations.length

        if (total <= maxItens) {
          return geolocations
        }

        const resultado = [geolocations[0]] // Garante que o primeiro item seja incluído
        const step = (total - 2) / (maxItens - 2) // Calcula o espaçamento entre os itens intermediários

        for (let i = 1; i < maxItens - 1; i++) {
          const index = Math.round(i * step)
          resultado.push(geolocations[index])
        }

        resultado.push(geolocations[total - 1]) // Garante que o último item seja incluído

        return resultado
      },

      changeLoadStatus(hasLoaded, origin = null) {
        // setState(prevState => {
        //   if (!prevState.firstRenderComplete) prevState.isLoading = !hasLoaded
        //   prevState.firstRenderComplete = !prevState.isLoading && !origin ? true : false
        //   return { ...prevState }
        // })
      },
    }
  }, [])

  return { state, localDispatch }
}
